/**
 * Gedeelde retourredenen (code + label) — magazijn, publiek formulier, export/analyse.
 * Alleen de `value` gaat in het veld `reden` in de API.
 */
export const RETOUR_REDEN_OPTIES = [
  { value: 'defect', label: 'Defect / beschadigd' },
  { value: 'verkeerd_artikel', label: 'Verkeerd artikel ontvangen' },
  { value: 'niet_naar_wens', label: 'Niet naar wens / past niet' },
  { value: 'te_laat', label: 'Te laat geleverd' },
  { value: 'annulering', label: 'Annulering' },
  { value: 'anders', label: 'Anders' },
];

export const RETOUR_REDEN_VALUE_ANDERS = 'anders';
